module.exports = __webpack_public_path__ + "img/swiper-4.96d3951.png";